import { getSupabase, isSupabaseConfigured } from '../lib/supabase';

/** @param {string} userId public.users.id */
export async function fetchExpiryReminders(userId) {
  if (!isSupabaseConfigured || !userId) return [];
  const supabase = getSupabase();
  if (!supabase) return [];
  const { data, error } = await supabase
    .from('expiry_reminders')
    .select('*')
    .eq('user_id', userId)
    .eq('is_active', true)
    .order('expiry_date', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function createExpiryReminder(payload) {
  if (!isSupabaseConfigured) return null;
  const supabase = getSupabase();
  if (!supabase) return null;
  const { data, error } = await supabase.from('expiry_reminders').insert(payload).select().single();
  if (error) throw error;
  return data;
}

export async function updateExpiryReminder(id, payload) {
  if (!isSupabaseConfigured) return null;
  const supabase = getSupabase();
  if (!supabase) return null;
  const { data, error } = await supabase
    .from('expiry_reminders')
    .update({ ...payload, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteExpiryReminder(id) {
  if (!isSupabaseConfigured) return null;
  const supabase = getSupabase();
  if (!supabase) return null;
  const { error } = await supabase.from('expiry_reminders').update({ is_active: false }).eq('id', id);
  if (error) throw error;
}
